import React from 'react';
import { useStaticQuery, graphql} from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { useLocalization } from "gatsby-theme-i18n";
import styled from '@emotion/styled';
import * as breakpoint from '../../styles/breakpoints.module.scss';

const Ticket = (props) => {
  const data = useStaticQuery(graphql`
  query Ticket {
    bg_normal : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/ticket_normal.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    bg_goods : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/ticket_goods.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
   
  }
`);
const { t } = useLocalization();
  let { date, title, option, price, type } = props;

  return(<Wrapper>
    <Content>
      <Top>
        <TicketInfo>
          <DateLabel>{date}</DateLabel>
          <NameLabel>{title}</NameLabel>
          {option && <OptionLabel>{option}</OptionLabel>}
        </TicketInfo>
        <BgImg image={type === "withGoods" ? getImage(data.bg_goods) : getImage(data.bg_normal) } alt="" />
      </Top>
      <Bottom>
        <PriceLabel>{parseInt(price,10).toLocaleString()+t('ticket.type.price.unit')}</PriceLabel>
        <span>{t('ticket.type.price.ext')}</span>
      </Bottom>
    </Content>
  </Wrapper>
  );
}

export default Ticket;

const Wrapper = styled.div`
  width:50%;
  padding-bottom:32px;

  &:nth-of-type(odd){
    padding-right:16px;
  }  
  &:nth-of-type(even){
    padding-left:16px;
  }  

  @media only screen and (max-width: ${breakpoint.xsMax}){
    width:100%;
    &:nth-of-type(odd){
      padding-right:0px;
    }  
    &:nth-of-type(even){
      padding-left:0px;
    }  
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding-bottom:16px;
  }
`

const Content = styled.div`
  background: #FFFFFF;
  /* Shadow / 1dp */

  box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
  border-radius: 6px;
  overflow:hidden;
`

const Top = styled.div`
  position:relative;
`;

const Bottom = styled.div`
  padding:16px 32px;
  text-align:right;
  font-size: 24px;
line-height: 32px;
letter-spacing: 0.01em;
color: #444448;

@media only screen and (max-width: ${breakpoint.smMax}){
  font-size: 20px;
  line-height: 28px;
}

@media only screen and (max-width: ${breakpoint.xsMax}){
  padding:8px 16px;
  font-size: 16px;
line-height: 24px;
}
`

const TicketInfo = styled.div`
  position:absolute;
  width:100%;
  height:100%;
  padding:32px;
  z-index:2;

  span{
    display:block;
    color: #FFFFFF;
    font-weight:bold;
    margin-bottom:8px;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:24px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding:16px;
    display:flex;
    flex-direction: column;
    justify-content:center;
  }
`

const DateLabel = styled.span`
font-size: 14px;
line-height: 24px;
letter-spacing: 0.07em;
@media only screen and (max-width: ${breakpoint.xsMax}){
  font-size: 12px;
  line-height: 20px;
}
`;

const NameLabel = styled.span`
font-size: 24px;
line-height: 32px;

letter-spacing: 0.07em;
@media only screen and (max-width: ${breakpoint.smMax}){
  font-size: 20px;
  line-height: 28px;
}
@media only screen and (max-width: ${breakpoint.xsMax}){
  font-size: 18px;
  line-height: 24px;
}
`;

const OptionLabel = styled.span`
font-size: 14px;
line-height: 24px;

letter-spacing: 0.07em;

@media only screen and (max-width: ${breakpoint.smMax}){
  font-size: 12px;
  line-height: 20px;
}
@media only screen and (max-width: ${breakpoint.xsMax}){
  font-size: 10px;
  line-height: 16px;
}
`

const BgImg = styled(GatsbyImage)`
box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
@media only screen and (max-width: ${breakpoint.smMax}){
  height:136px;
}

@media only screen and (max-width: ${breakpoint.xsMax}){
  height:108px;
}
`

const PriceLabel = styled.span`
  margin-right:8px;
  font-weight:bold;
`
